import { render, staticRenderFns } from "./CustomMask.vue?vue&type=template&id=f0f9f3e0&scoped=true&"
import script from "./CustomMask.vue?vue&type=script&lang=js&"
export * from "./CustomMask.vue?vue&type=script&lang=js&"
import style0 from "./CustomMask.vue?vue&type=style&index=0&id=f0f9f3e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f9f3e0",
  null
  
)

export default component.exports